import { render } from "./AdditionalQuestions.vue?vue&type=template&id=2eda9d94&scoped=true"
import script from "./AdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestions.vue?vue&type=script&lang=js"

import "./AdditionalQuestions.vue?vue&type=style&index=0&id=2eda9d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eda9d94"]])

export default __exports__